import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_ALL_RACKS } from "./actionTypes";
import { getAllRacksSuccess, getAllRacksError } from "./actions";

// Include call API
import { getRacksAPI } from "../../../api/racks";

const racksAPI = getRacksAPI();

function* getAllRacks({ payload: { user } }) {
  try {
    console.log("SAGA");
    var response = yield call(racksAPI.getAllRacks, user);
    console.log("Response: ", response);
    yield put(getAllRacksSuccess(response.racks, response.message));
  } catch (error) {
    yield put(getAllRacksError(error));
  }
}

export function* watchGetAllRacks() {
  yield takeEvery(GET_ALL_RACKS, getAllRacks);
}

function* getAllRacksSaga() {
  yield all([fork(watchGetAllRacks)]);
}

export default getAllRacksSaga;
